module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-lock2-fill-98ca1375.svg";